import React, { useState } from "react";
import { Headset, X, Phone, PhoneCall, MessageCircle } from "lucide-react";

const WA_NUMBER = "18257772325";       // WhatsApp (no '+')
const TEL_NUMBER = "+18257772325";
const WA_CHAT_URL = `https://wa.me/${WA_NUMBER}`;

const ACTIONS = [
  {
    key: "wa-call", label: "Call on WhatsApp",
    hint: "Opens our WhatsApp chat — tap the call button there",
    Icon: PhoneCall, tint: "text-success", bg: "bg-success/10",
    run: () => window.open(WA_CHAT_URL, "_blank"),
  },
  {
    key: "phone-call", label: "Call by phone",
    hint: TEL_NUMBER, Icon: Phone, tint: "text-primary", bg: "bg-primary/10",
    run: () => { window.location.href = `tel:${TEL_NUMBER}`; },
  },
  {
    key: "wa-message", label: "Message on WhatsApp",
    hint: "Send us a message on WhatsApp",
    Icon: MessageCircle, tint: "text-success", bg: "bg-success/10",
    run: () => window.open(WA_CHAT_URL, "_blank"),
  },
];

export function HelpPanel({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60]" data-testid="customer-help-overlay">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div
        className="absolute left-3 top-16 w-[min(20rem,calc(100vw-1.5rem))] overflow-hidden rounded-2xl border border-border bg-surface shadow-2xl"
        data-testid="customer-help-panel"
      >
        <div className="flex items-center justify-between border-b border-border px-4 py-3">
          <p className="font-heading text-sm font-semibold text-text-main">Need help?</p>
          <button type="button" onClick={onClose} data-testid="customer-help-close" className="text-text-muted hover:text-text-main">
            <X size={16} strokeWidth={1.5} />
          </button>
        </div>
        <div>
          {ACTIONS.map(({ key, label, hint, Icon, tint, bg, run }) => (
            <button
              key={key}
              type="button"
              onClick={() => { run(); onClose(); }}
              className="flex w-full items-center gap-3 border-b border-border/60 px-4 py-3 text-left transition-colors hover:bg-background active:bg-background"
              data-testid={`customer-help-${key}`}
            >
              <span className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full ${bg} ${tint}`}>
                <Icon size={16} strokeWidth={1.75} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-semibold text-text-main">{label}</span>
                <span className="block truncate text-xs text-text-muted">{hint}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export function HelpButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="absolute left-4 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 text-white/80 transition-colors active:scale-95 hover:bg-white/10 hover:text-white"
        data-testid="customer-help-button"
        aria-label="Help"
      >
        <Headset size={17} strokeWidth={1.5} />
      </button>

      <HelpPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
}
